import React from 'react';
import cx from 'classnames';
import styles from './salesloftConfigurationView.module.scss';
import isEqual from 'is-equal';
import { toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import {  Row, Col, Form, FormGroup, InputGroup, FormControl
} from 'react-bootstrap';
import SendButton from 'src/legacy/components/SendButton';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import AccessDeniedIcon from 'src/legacy/images/access_denied.svg';
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from 'src/components/toast';
import SwitchButton from 'src/components/switchButton';


class SalesloftConfigurationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      email: integration && integration.configuration.email || '',
      syncReadAssetEvent: integration && integration.configuration.syncReadAssetEvent || false,
      syncReadConversationEvent: integration && integration.configuration.syncReadConversationEvent || false,
      syncReshareConversationEvent: integration && integration.configuration.syncReshareConversationEvent || false,
      syncLeadCreatedEvent: integration && integration.configuration.syncLeadCreatedEvent || false,
      errors: {}
    }

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedSalesloft = localizedStrings.components.integrations.salesloft;
  }

  componentDidMount() {   
  }

  _toggleSwitchChange(field){
    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(){
  
    let request = {
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.state.syncLeadCreatedEvent
    }

    this.props.updateConfiguration(request).then(() => {
        toast(
          <Toast.Sucess
              message = {this.localizedIntegrations.toast.salesloft}           
          /> , {
            autoClose: 3000,
        })
    });
  }

  _handleResetClicked(){
    this.setState({
      syncReadAssetEvent: this.props.integration.configuration.syncReadAssetEvent,
      syncReadConversationEvent: this.props.integration.configuration.syncReadConversationEvent,
      syncReshareConversationEvent: this.props.integration.configuration.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.props.integration.configuration.syncLeadCreatedEvent
    });
  }

  render(){
    return (
      <div className={styles.content}>
        {this.props.integration && this.props.integration.state.code === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {this.props.loading && this._renderLoading()}

        {!this.props.loading && this._renderAdminConfiguration()}

      </div>
    )
  }

  _renderAdminConfiguration() {
    return (
        <Row className={styles.row}>
          <Col md={8} mdOffset={1}>
            <div className={styles.form}>
              <p className={styles.errorMessage}>{this.state.errors && this.state.errors.apikey}</p>
              
              <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className = {styles.disableEmail}>
                <div className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </div>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.email}
                  disabled/>
              </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedSalesloft.active }</Form.Text>


              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <h5>{ this.localizedIntegrations.sync_events }</h5>
                </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedSalesloft.config }</Form.Text>

              <FormGroup className={cx(styles.formGroup, styles.events)}>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_asset }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReadAssetEvent"
                    checked={this.state.syncReadAssetEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadAssetEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReadConversationEvent"
                    checked={this.state.syncReadConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReshareConversationEvent"
                    checked={this.state.syncReshareConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.create_lead }</label>
                  <SwitchButton 
                    id="syncLeadCreatedEvent"
                    className={styles.switch}
                    checked={this.state.syncLeadCreatedEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncLeadCreatedEvent")} />
                </div>
              </FormGroup>


              <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="fa-chevron-right"
                  title={this.props.updating ? `${this.localizedCommons.actions.saving_changes}...` : this.localizedCommons.actions.save }
                  primary
                  disabled={this.props.updating}
                  onClick={this._handleSaveChangesClicked}
                >
                </SendButton>
                <SendButton
                  title={this.localizedCommons.actions.reset}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={this._handleResetClicked}
                >
                </SendButton>
              </div>
            </div>
          </Col>
        </Row>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedSalesloft.title}
        message={this.localizedSalesloft.empty_message.sub_text}
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage 
        className={styles.loadingMessage}
        message={`${this.localizedSalesloft.loading}...`}
        visible={true} />
    )
  }
}

export default SalesloftConfigurationView;